import { Component, OnInit } from '@angular/core';
import { ICheckFilter } from 'src/app/modules/core/interfaces/check-filter';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { IOutputFilter } from 'src/app/modules/core/interfaces/output-filter';
import { Observable } from 'rxjs';
import { ReportChecklistService } from '../../../services/report-checklist.service';
import { IResponse } from 'src/app/modules/core/interfaces/response';
import { map, catchError } from 'rxjs/operators';
import { ILayoutConfig } from 'src/app/modules/layout/interfaces/layout-config';
import { LayoutConfigService } from 'src/app/modules/layout/services/layout-config.service';
import { IFilterConfig } from 'src/app/modules/core/interfaces/filter-config';
import { COMPANIES_ID } from 'projects/common/src/app/enumerables/companies-id';
import { CacheService } from 'projects/common/src/app/services';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';

@Component({
  selector: 'app-checklist-shell',
  templateUrl: './checklist-shell.component.html',
  styleUrls: ['./checklist-shell.component.scss'],
})
export class ChecklistShellComponent implements OnInit {
  public message: string;
  public showFilter: ICheckFilter;
  public reportData$: Observable<IResponse>;
  public systemError: string;
  public filterConfig: IFilterConfig;
  public isMtv = false;

  constructor(
    private langService: LanguageService,
    private reportChecklistService: ReportChecklistService,
    private cacheService: CacheService,
    private layoutConfigService: LayoutConfigService,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) {
    const companyId = this.cacheService.local('session').user.company.id;
    this.isMtv = companyId === COMPANIES_ID.MTV;
    if (this.isMtv) {
      this.filterConfig = {
        dates: { required: true },
        shift: { required: true },
        machineType: { required: true, isForMtv: true },
        machineList: { required: true, multiselect: true },
        cleanButton: true,
      };
    } else {
      this.filterConfig = {
        dates: { required: true },
        shift: { required: true },
        machineType: { required: true, multiselect: true },
        machineList: { required: true, multiselect: true },
        cleanButton: true,
      };
    }
  }

  /**
   * Init component
   */
  public ngOnInit(): void {
    const config: ILayoutConfig = {
      title: 'reports',
      subtitle: 'report-checklist',
      imageKey: 'report',
      imageType: 'section',
    };
    this.layoutConfigService.setConfig(config);
  }

  /**
   * Get report data from Api
   */
  public search($event: IOutputFilter): void {
    this.filterConfig.isLoading = true;

    this.reportData$ = this.reportChecklistService.getCheckListReport($event).pipe(
      map((data) => {
        this.filterConfig.isLoading = false;
        this.systemError = '';
        this.message = null;

        if (!data.length) {
          this.message = this.langService.message('m034');
        }

        return data || [];
      }),
      catchError(({ name }) => {
        this.message = null;
        this.systemError = name === 'TimeoutError' ? 'm014' : 'm017';
        this.filterConfig.isLoading = false;
        return [];
      }),
    );
    const filters = {
      reports: 'report-checklist',
    };
    this.googleAnalyticsService.sendCustomEvent('filter', filters);
  }
}
